export const VW_VISIBLE_HEADER_FIELDS = new Set<string>([
  'customer_id',
  'organization_id',
  'supplier_id',
  'supplier_name',
  'invoice_currency',
  'document_type',
  'invoice_number',
  'invoice_date',
  'purchase_order_number',
  'total_vat_included_amount',
  'total_vat_excluded_amount',
  'total_vat_amount',
  'total_vat_rate_percent',
  'exception_message',
]);
